import Footer from './Footer.vue';

export default Footer;
